import Store from "@/store/index.js";
import axios from "axios";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
const domain = Store.state.domain;
export default {

    async ObtenerCatalogoTramites(vm, cetipo) {
        var datos = new FormData();
        datos.append("cetipo", cetipo);
        datos.append("aiclave", vm.reporte.aiclave);
        datos.append("nrreporte", vm.reporte.nrreporte);
        datos.append("svindice", vm.reporte.svindice);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}ReporteGeneral/CatalogoTipoTramites`, datos);
        vm.Tramites.opcionesTramites = response.data;
    },
    async GuardarTramite(vm, tramite) {
        var datos = new FormData();
        datos.append("aiclave", vm.reporte.aiclave);
        datos.append("nrreporte", vm.reporte.nrreporte);
        datos.append("svindice", vm.reporte.svindice);

        datos.append("ceclave", tramite.ceclave);
        datos.append("obs", MetodosGenerales.SanitizarTexto(tramite.observaciones));
        datos.append("respuesta", tramite.respuesta);
        datos.append("FechaMovTram", tramite.fecha);
        datos.append("esid", tramite.esid);

        datos.append("destinatario", tramite.tCorreoPara);
        datos.append("CC", tramite.tCorreoCopia);
        datos.append("Asunto", tramite.tAsunto);
        datos.append("Mensaje", tramite.txtMensaje);
        datos.append("documentos", tramite.documentos);

        datos.append("seleccion", tramite.valDatoPrueba);
        datos.append("opiontecnica", tramite.opiontecnica);
        datos.append("dato1", tramite.dato1);
        datos.append("dato2", tramite.dato2);
        datos.append("dato3", tramite.dato3);
        datos.append("dato4", tramite.dato4);
        datos.append("dato5", tramite.dato5);
        datos.append("indicios", tramite.indicios);
        datos.append("saprocivil", tramite.procesoCivil);

        let response = await vm.axios.post(`${vm.domain.domainNameForApi}ReporteGeneral/GuardarTramite`, datos);
        return response.data;
    },
    /* async GuardarTramite(vm, ceclave, obs, respuesta, FechaMovTram, esid, destinatario, CC, Asunto, Mensaje, documentos,
        seleccion, opiontecnica, dato1, dato2, dato3, dato4, dato5, indicios) {
        let datosrep = await MetodosGenerales.obtenerSessionReporte("reporte");
        var datos = new FormData();
        datos.append("aiclave", datosrep.aiclave);
        datos.append("nrreporte", datosrep.nrreporte);
        datos.append("svindice", datosrep.svindice);
        datos.append("ceclave", ceclave);
        datos.append("obs", obs);
        datos.append("respuesta", respuesta);
        datos.append("FechaMovTram", FechaMovTram);
        datos.append("destinatario", destinatario);
        datos.append("CC", CC);
        datos.append("Asunto", Asunto);
        datos.append("Mensaje", Mensaje);
        datos.append("documentos", documentos);
        datos.append("esid", esid);
        datos.append("seleccion", seleccion);
        datos.append("opiontecnica", opiontecnica);
        datos.append("dato1", dato1);
        datos.append("dato2", dato2);
        datos.append("dato3", dato3);
        datos.append("dato4", dato4);
        datos.append("dato5", dato5);
        datos.append("indicios", indicios);

        let response = await vm.axios.post(`${vm.domain.domainNameForApi}ReporteGeneral/GuardarTramite`, datos);
        return response.data;
    }, */
    async CatalogoDatosPrueba(vm) {
        let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/CatalogoDatosPrueba`);
        vm.datosPrueba = response.data.data;
    },
    async CatalogoOpcionTecnica(vm, cdpclave) {
        var datos = new FormData();
        datos.append("cdpclave", cdpclave);
        let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/CatalogoOpcionTecnica`, datos);
        vm.opcionTec = response.data.data;
    },
    async ObtenerDatosPruebaReporteInforme(vm) {
        var datos = new FormData();
        datos.append("nrreporte", vm.reporte.nrreporte);
        datos.append("svindice", vm.reporte.svindice);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}ReporteGeneral/ObtenerDatosPruebaReporteInforme`, datos);
        return response.data;
    },
    async ValidarPrecierre(vm) {
        var datos = new FormData();
        datos.append("nrreporte", vm.reporte.nrreporte);
        datos.append("svindice", vm.reporte.svindice);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}ReporteGeneral/ValidarPrecierre`, datos);
        return response.data;
    },
    async CheckListPreguntasAbogado(vm) {
        var datos = new FormData();
        datos.append("nrreporte", vm.reporte.nrreporte);
        datos.append("svindice", vm.reporte.svindice);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}ReporteGeneral/CheckListPreguntasAbogado`, datos);
        return response.data;
    },

    async CheckListAbogadoValMovimientos(vm, claid) {
        var datos = new FormData();
        datos.append("nrreporte", vm.reporte.nrreporte);
        datos.append("svindice", vm.reporte.svindice);
        datos.append("claid", claid);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}ReporteGeneral/CheckListAbogadoValMovimientos`, datos);
        return response.data;
    },
    async ValidacionCLAbogadoNA(vm, respuestas) {
        var datos = new FormData();
        datos.append("respuestas", respuestas);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}ReporteGeneral/ValidacionCLAbogadoNA`, datos);
        return response.data;
    },
    async GuardarRespuestasAbogado(vm, respuestas, estatus, tipo, firma) {
        var datos = new FormData();
        datos.append("nrreporte", vm.reporte.nrreporte);
        datos.append("svindice", vm.reporte.svindice);
        datos.append("respuestas", respuestas);
        datos.append("estatus", estatus);
        datos.append("tipo", tipo);
        datos.append("firma", firma);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}ReporteGeneral/GuardarRespuestasAbogado`, datos);
        return response.data;
    },
    async validarcarta(vm, ceclave) {
        var datos = new FormData();
        datos.append("nrreporte", vm.reporte.nrreporte);
        datos.append("svindice", vm.reporte.svindice);
        datos.append("ceclave", ceclave);

        let response = await vm.axios.post(`${vm.domain.domainNameForApi}ReporteGeneral/validarcarta`, datos);
        return response.data;
    },
    async EnviarCarta(vm, fecha, ceclave, emailTo, asuntoTo, cc, Mensaje) {
        let datosrep = await MetodosGenerales.obtenerSessionReporte("reporte");
        var datos = new FormData();
        datos.append("nrreporte", datosrep.nrreporte);
        datos.append("svindice", datosrep.svindice);
        datos.append("fecha", fecha);
        datos.append("ceclave", ceclave);
        datos.append("emailTo", emailTo);
        datos.append("asuntoTo", asuntoTo);
        datos.append("cc", cc);
        datos.append("mensaje", Mensaje.replace("\\r\\n", "<br>"));
        ///text.replace("\\r\\n", "<br>");
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}ReporteGeneral/EnviarCarta`, datos);
        return response.data;
    },
    async DatosGeneralesInforme(vm) {
        var datos = new FormData();
        datos.append("nrreporte", vm.reporte.nrreporte);
        datos.append("svindice", vm.reporte.svindice);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}ReporteGeneral/DatosGeneralesInforme`, datos);
        return response.data;
    },
    async ObtenerCatalogoIndicio(vm) {
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}ReporteGeneral/ObtenerCatalogoIndicio`);
        vm.datosIndicios = response.data;
    },
    async ValidacionesTramites(reporte) {
        var datos = new FormData();
        datos.append("nrreporte", reporte.nrreporte);
        datos.append("svindice", reporte.svindice);
        datos.append("aiclave", reporte.aiclave);
        let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/ValidacionesTramites`, datos);
        return response.data[0];
    },
    async ValidarMovimientosTramites(ceclave) {
        var datos = new FormData();
        datos.append("ceclave", ceclave);
        let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/ValidarMovimientosTramites`, datos);
        return response.data;
    },
    async ObtenerIndicios(reporte) {
        var datos = new FormData();
        datos.append("nrreporte", reporte.nrreporte);
        datos.append("svindice", reporte.svindice);
        let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/ObtenerIndicios`, datos);
        return response.data;
    },
    async ValidarMovimientoTramite(vm, ceclave) {
        var datos = new FormData();
        datos.append("nrreporte", vm.reporte.nrreporte);
        datos.append("svindice", vm.reporte.svindice);
        datos.append("ceclave", ceclave);
        let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/ValidarMovimientoTramite`, datos);

        return response.data;
    }
}

